

<template>
      
      

  <div class="row">
  <div class="col-sm-3 col-lg-3 col-xxl-3" v-for="kullanici in paginatedkullanicilar" :key="kullanici.id"  :class="{ 'tableactivetr': kullanici.id === (kullanicilar.secili && kullanicilar.secili.id) }">
<div class="card card-bordered">
    <div class="card-inner">
        <div class="team">
            <div class="team-status bg-light text-black"></div>
           
            <div class="user-card user-card-s2" @click="detay(kullanici)">
                <div class="user-avatar md bg-primary"> <img :src="$globalVariable.uploadUrl + kullanici.profil"  @error="$globalVariable.varsayilanGorsel" alt="">
                </div>
                <div class="user-info">
                    <h6> {{ kullanici.ad }} {{ kullanici.soyad }}</h6><span class="sub-text">{{ kullanici.rol_ad }}</span>
                </div>
            </div>
       
          
            <div class="team-view">
              <a href="#" class="btn btn-trigger btn-icon"  @click="detay(kullanici)">
            <em class="icon ni ni-eye"></em>
          </a>
              <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('kullanici_duzenle')" @click="duzenle(kullanici)">
            <em class="icon ni ni-pen"></em>
          </a>
        
     
          <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('kullanici_sil')" @click="sil(kullanici.id)">
            <em class="icon ni ni-trash-alt"></em>
          </a>
          
                  </div>
        </div>
    </div>
</div>
</div>
</div>



<div class="card-inner">
        <div class="nk-block-between-md g-3">
          <div class="g">
            <ul class="pagination justify-content-center justify-content-md-start">
              <li :class="{ active: page === kullanicilar.seciliSayfa, 'page-item': true }" v-for="page in pages"
                :key="page">
                <a class="page-link" href="#" @click="kullanicilarSayfaDegistir(page)">{{ page }}</a>
              </li>

            </ul>
          </div>

        </div>
      </div>




   

 </template>
 

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';

export default {
  props: {

    kullanicilar:{
      type: Array,
      required: true
    },
    duzenle: Function,
    detay: Function,
    formKaydetSonrasi: Function,
    tur:String,
  },
  computed: {
    filteredkullanicilar() {
      // Arama filtresine göre kullanıcıları filtrele
      return this.kullanicilar.tumu.filter(
        (kullanici) =>

          kullanici.ad.toLowerCase() 
          
          .includes(this.kullanicilar.arananKelime.toLowerCase()) ||kullanici.ad.toLowerCase()
          
          .includes(this.kullanicilar.arananKelime.toLowerCase()) ||kullanici.soyad.toLowerCase()
          
          .includes(this.kullanicilar.arananKelime.toLowerCase()) ||kullanici.kullaniciadi.toLowerCase()
          
          .includes(this.kullanicilar.arananKelime.toLowerCase()) ||kullanici.telefon.toLowerCase()
          
          
          .includes(this.kullanicilar.arananKelime.toLowerCase())


    
      );
    },
    paginatedkullanicilar() {
      const start = (this.kullanicilar.seciliSayfa - 1) * this.kullanicilar.sayfadaKayit;
      const end = start + this.kullanicilar.sayfadaKayit;
      return this.filteredkullanicilar.slice(start, end);
    },
    kullanicilar_toplamSayfa() {
      const totalFilteredUsers = this.filteredkullanicilar.length;
      const maxPage = Math.max(Math.ceil(totalFilteredUsers / this.kullanicilar.sayfadaKayit), 1);
      if (this.kullanicilar.seciliSayfa > maxPage) {
        this.kullanicilarSayfaDegistir(maxPage);
      }
      return maxPage;
    },
    pages() {
        const totalPageCount = this.kullanicilar_toplamSayfa;
        const maxVisiblePages = 5;
        const currentPage = this.kullanicilar.seciliSayfa;

        if (totalPageCount <= maxVisiblePages) {
            return Array.from({ length: totalPageCount }, (_, index) => index + 1);
        }

        const pagesBefore = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
        const pagesAfter = Math.min(pagesBefore + maxVisiblePages - 1, totalPageCount);

        return Array.from({ length: pagesAfter - pagesBefore + 1 }, (_, index) => pagesBefore + index);
    },
  
  },
  methods: {
    yetki_kontrol(yetki){
      return yetkiKontrol(yetki);
    },
    async sil(kullaniciId) {
      const result = await this.$swal({
        title: "Emin misiniz?",
        text: "Bu işlemi geri alamayacaksınız!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "İptal",
      });

      if (result.isConfirmed) {
        try {
          await axiosCustom.post("kullanicilar/sil/" + kullaniciId);
          this.$toast.success("Kayıt Silindi");
          this.formKaydetSonrasi();
        } catch (error) {
          console.error("Silme hatası: ", error);
          this.$toast.error("Silme hatası");
        }
      }
    },
    kullanicilarSayfaDegistir(page) {
      this.$emit('update:kullanicilar',{
      ...this.kullanicilar,
      seciliSayfa: page
    });
    },
    kullanicilarSayfadaKayitDegistir(value) {
      this.$emit('update:kullanicilar',{
      ...this.kullanicilar,
      sayfadaKayit: value
    });
      this.kullanicilarSayfaDegistir(1);
    },
  },
};
</script>
